import type { Location } from "@/types/content";

export const locations: Location[] = [
  {
    id: "loc-1",
    slug: "taipei",
    name: "台北",
    description: "台北是台灣美業最密集的城市，從中山區的精品SPA到大安區的皮膚管理工作室，應有盡有。中山區、大安區、信義區都是美業聚集熱點。",
    coverImage: "https://readdy.ai/api/search-image?query=Taipei%20city%20skyline%20at%20sunset%20with%20Taipei%20101%20modern%20urban%20landscape%20dramatic%20sky%20professional%20photography%20simple%20background&width=1200&height=630&seq=601&orientation=landscape",
    articleIds: ["post-1", "post-2", "post-5", "post-6", "post-7", "post-8", "post-9"],
    storeIds: ["svc-1", "svc-2", "svc-3", "svc-4", "svc-7", "svc-8"],
  },
  {
    id: "loc-2",
    slug: "taipei-zhongshan",
    name: "台北中山區",
    description: "台北中山區是美業的黃金地段，精品SPA、美容工作室與美髮沙龍密度極高，是追求質感生活的首選區域。",
    coverImage: "https://readdy.ai/api/search-image?query=Zhongshan%20district%20Taipei%20Taiwan%20elegant%20shopping%20street%20with%20boutique%20beauty%20salons%20and%20spa%20studios%20warm%20afternoon%20light%20urban%20lifestyle%20photography%20simple%20background&width=1200&height=630&seq=602&orientation=landscape",
    articleIds: ["post-1", "post-7"],
    storeIds: ["svc-1", "svc-3", "svc-8"],
  },
  {
    id: "loc-3",
    slug: "taipei-daan",
    name: "台北大安區",
    description: "台北大安區匯聚了大量皮膚管理工作室與高端美容診所，復興南路與忠孝東路是美容保養的探店重點路段。",
    coverImage: "https://readdy.ai/api/search-image?query=Daan%20district%20Taipei%20Taiwan%20upscale%20beauty%20clinic%20and%20wellness%20center%20exterior%20modern%20design%20professional%20atmosphere%20simple%20background%20photography&width=1200&height=630&seq=603&orientation=landscape",
    articleIds: ["post-2", "post-5"],
    storeIds: ["svc-7"],
  },
  {
    id: "loc-4",
    slug: "taipei-xinyi",
    name: "台北信義區",
    description: "台北信義區以高端精品著稱，百貨商圈內的SPA與美容中心服務品質頂尖，是商務人士與追求精緻體驗者的首選。",
    coverImage: "https://readdy.ai/api/search-image?query=Xinyi%20district%20Taipei%20Taiwan%20modern%20luxury%20shopping%20mall%20exterior%20with%20glass%20facade%20evening%20lighting%20premium%20urban%20district%20photography%20simple%20background&width=1200&height=630&seq=604&orientation=landscape",
    articleIds: ["post-9"],
    storeIds: ["svc-2", "svc-4"],
  },
  {
    id: "loc-5",
    slug: "newtaipei",
    name: "新北",
    description: "新北擁有豐富的美業資源，從永和的平價美甲美睫到板橋的SPA會館，多元選擇滿足各種預算需求。",
    coverImage: "https://readdy.ai/api/search-image?query=New%20Taipei%20city%20modern%20urban%20landscape%20with%20colorful%20buildings%20and%20river%20view%20lifestyle%20photography%20simple%20background&width=1200&height=630&seq=605&orientation=landscape",
    articleIds: ["post-3", "post-4"],
    storeIds: [],
  },
  {
    id: "loc-6",
    slug: "taichung",
    name: "台中",
    description: "台中美業文化蓬勃發展，西區的質感美容工作室與審計新村周邊的特色美甲店，吸引大批外縣市粉絲專程前來。",
    coverImage: "https://readdy.ai/api/search-image?query=Taichung%20city%20aerial%20view%20modern%20architecture%20and%20green%20spaces%20urban%20landscape%20photography%20simple%20background&width=1200&height=630&seq=606&orientation=landscape",
    articleIds: ["post-10", "post-11"],
    storeIds: [],
  },
  {
    id: "loc-7",
    slug: "kaohsiung",
    name: "高雄",
    description: "高雄美業以親民價格與在地熱情著稱，三多商圈與草衙道周邊的按摩館與美容院，CP值令北部人羨慕。",
    coverImage: "https://readdy.ai/api/search-image?query=Kaohsiung%20harbor%20at%20sunset%20modern%20architecture%20waterfront%20cityscape%20beautiful%20sky%20photography%20simple%20background&width=1200&height=630&seq=607&orientation=landscape",
    articleIds: ["post-21"],
    storeIds: [],
  },
  {
    id: "loc-8",
    slug: "tainan",
    name: "台南",
    description: "台南的美業結合了在地文化底蘊，老宅改造的美容工作室風格獨特，國華街、海安路周邊是探店好去處。",
    coverImage: "https://readdy.ai/api/search-image?query=Historic%20Tainan%20city%20street%20with%20traditional%20Taiwanese%20architecture%20and%20red%20brick%20buildings%20warm%20evening%20lighting%20photography%20simple%20background&width=1200&height=630&seq=608&orientation=landscape",
    articleIds: ["post-13"],
    storeIds: ["svc-11"],
  },
  {
    id: "loc-9",
    slug: "hsinchu",
    name: "新竹",
    description: "新竹科技人口密集，下班後的放鬆需求旺盛，竹科周邊的SPA與按摩館競爭激烈，品質普遍有一定水準。",
    coverImage: "https://readdy.ai/api/search-image?query=Hsinchu%20city%20skyline%20at%20dusk%20with%20modern%20technology%20park%20buildings%20and%20traditional%20cityscape%20warm%20sunset%20colors%20photography%20simple%20background&width=1200&height=630&seq=609&orientation=landscape",
    articleIds: ["post-19"],
    storeIds: [],
  },
  {
    id: "loc-10",
    slug: "yilan",
    name: "宜蘭",
    description: "宜蘭是台北人的週末療癒聖地，美業工作室與按摩會館密度雖不及台北，但服務更親切、價格更實惠，搭配在地農產特色療程，是探店愛好者的隱藏寶地。",
    coverImage: "https://readdy.ai/api/search-image?query=Yilan%20green%20rice%20fields%20with%20mountain%20backdrop%20peaceful%20rural%20landscape%20taiwan%20countryside%20photography%20simple%20background&width=1200&height=630&seq=610&orientation=landscape",
    articleIds: ["post-15"],
    storeIds: [],
  },
];